<div class="custom-mat-dialog-form factor-dialog">
  <h3>{{this.data ? 'Update' : 'Create new'}} Excellence Factor</h3>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="factor-dialog__form">
    <div class="factor-dialog__body">

      <div class="row">
        <div class="form-group">
          <mat-form-field appearance="outline">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name" required>
          </mat-form-field>

          @if (
            form.get('name')?.invalid &&
            (form.get('name')?.dirty ||
            form.get('name')?.touched)) {
            <p>
              @if (form.get('name')?.hasError('required')) {
                <mat-error>This field is required</mat-error>
              }
            </p>
          }
        </div>
      </div>

      <div class="row">
        <div class="form-group">
          <mat-form-field appearance="outline">
            <mat-label>Description</mat-label>
            <textarea matInput formControlName="description" rows="2" required></textarea>
          </mat-form-field>

          @if (
            form.get('description')?.invalid &&
            (form.get('description')?.dirty ||
            form.get('description')?.touched)) {
            <p>
              @if (form.get('description')?.hasError('required')) {
                <mat-error>This field is required</mat-error>
              }
            </p>
          }
        </div>
      </div>

      <div class="row form-row-align">
        <div class="col-sm-4 form-group">
          <mat-label><span>Group Function Filter</span></mat-label>
        </div>
        <div class="col-sm-8 form-group">
          <ng-select [items]="groupFunctions"
            [searchable]="true"
            [clearable]="true"
            [(ngModel)]="selectedGroupFunction"
            [ngModelOptions]="{standalone: true}"
            (change)="onGroupFunctionChange($event)">
          </ng-select>
        </div>
      </div>

      <div class="row form-row-align">
        <div class="col-sm-4 form-group">
          <mat-label><span>Excellence Lever</span><span class="orange-asterisk"> *</span></mat-label>
        </div>
        <div class="col-sm-8 form-group">
          <ng-select [items]="excellenceLevers"
            [searchable]="true"
            [clearable]="false"
            bindLabel="Name"
            bindValue="ExcellenceLeverId"
            formControlName="excellenceLeverId"
            required>
          </ng-select>
        </div>
      </div>


      <div class="row">
        <div class="col-sm-12 form-group">
          <mat-label><span>Archetypes</span></mat-label>
          <div class="archetype-list">
            @for (archetype of archetypes; track archetype.Id) {
              <mat-checkbox
                class="archetype-item"
                [checked]="isArchetypeSelected(archetype.Id)"
                (change)="onArchetypeToggle(archetype.Id, $event.checked)">
                <span [title]="archetype.Description">{{archetype.Description}}</span>
              </mat-checkbox>
            }
            @if (archetypesLoaded && archetypes.length === 0) {
              <p class="archetype-empty">No archetypes available</p>
            }
            @if (archetypesFailed) {
              <p class="archetype-empty">Archetypes could not be loaded</p>
            }
          </div>
          <p class="archetype-hint">None selected: the factor applies to every archetype.</p>
        </div>
      </div>

    </div>

    <div class="factor-dialog__footer">
      <button (click)="backButtonHandler($event)" mat-raised-button class="btn button-color-fix_red">
        <mat-icon class="icon-color-fix">arrow_back_ios</mat-icon>
        Back
      </button>
      <button mat-raised-button type="submit" class="btn button-color-fix" [disabled]="!form.valid">
        {{this.data ? 'Update' : 'Create'}}
        <mat-icon class="icon-color-fix">save</mat-icon>
      </button>
    </div>
  </form>
</div>
